import { isNumber, isString } from 'lodash';
import numeral from 'numeral';
export function filesize(value) {
    if (isNumber(value) || isString(value)) {
        return numeral(value).format('0.0 ib');
    }
    return '';
}
export function preformat(value) {
    if (isString(value)) {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    return value;
}
//# sourceMappingURL=filters.js.map